import { FrontsIcon } from 'components/ProductSidebar/ProductGroupNav/ProductGroupNavSVGs';
import { ProductGroup } from 'rangeConfig/@types';
import selectedMenu from './selectedMenu';
import { ProductType } from '@inter-ikea-storageone/range';
import mainMenu from './mainMenu';

const fronts = (): ProductGroup => {
  return {
    id: 'fronts',
    productTypes: [
      ProductType.BESTA_DOOR_38_ASM,
      ProductType.BESTA_DOOR_64_ASM,
      ProductType.BESTA_DRAWER_26_ASM,
      ProductType.BESTA_DRAWER_38_ASM,
      ProductType.BESTA_DOOR_192_ASM
    ],
    icon: FrontsIcon,
    mainMenu: mainMenu(),
    selectedMenu: selectedMenu()
  };
};

export default fronts;
